import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { callautopopulate } from '../../../services/callautopop';
import { Urls } from '../../../services/Urls';
import services from '../../../services/services';
import { dateConvert, formatDateObject } from '../../../utils/Helper';
import { useCommon } from "../Pocker/useCommon";
import { DateObject } from 'react-multi-date-picker';
import { Dropdown } from 'primereact/dropdown';
import { useMyBucket } from '../Pocker/useMyBucket';
import { useTaskDetailsPopup } from '../ProjectGlance/useTaskDetailsPopup';
import _ from "underscore";
import { ToastContext } from '../../../context/ToastContext';
import { useNavigate } from 'react-router-dom';
import { SkeletonContainer } from '../../../components/Loader/Loader';
import { decryptData, encryptData } from '../../../utils/encrypt';

export const useTaskList = () => {
    const { showSuccess } = useContext(ToastContext);
    const { getPriorityIcon, getSubProject, getUserInitials } = useCommon();
    const { handleStatusChange, statusOptionsByRow, setStatusOptionsByRow, selectedStatusByRow, setSelectedStatusByRow, getProjectUser, loadStatusOptions, setPopupValue, updateReviewer, popupValue, options } = useMyBucket({ fromTaskList: true });
    const { configOpts, listBoxOptionTemplate, displayColumns, setDisplayColumns, saveColumnConfiguration } = useTaskDetailsPopup({ projectId: 0, detailsPopup: {}, payloadData: {}, header: "" }); //fromTaskList: true
    const [taskDetailsPopup, setTaskDetailsPopup] = useState({ show: false });
    const now = new Date();
    const firstDay = new Date(now?.getFullYear(), now?.getMonth(), 1);
    const lastDay = new Date(now?.getFullYear(), now?.getMonth() + 1, 0);
    const [filterValue, setFilterValue] = useState({ search: "", groups: null, allTasks: [], createdDate: [new DateObject(firstDay), new DateObject(lastDay)], assigneeImgError: {}, reporterImgError: {}, selectedFilterKey: "", firstTimeApi: false, isChange: false });
    const [option, setOption] = useState({});
    const [rowdata, setRowData] = useState([]);
    const [expanded, setExpanded] = useState(true);
    const [loader, setLoader] = useState(true);
    const [tasks, setTasks] = useState([])
    const [pagination, setPagination] = useState({ total_records: 0, total_pages: 0, current_page: 1, display_page_out_of_total: "" });
    const taskListRef = useRef();
    const overlayRef = useRef(null);
    const multiselectRef = useRef(null);
    const [hoveredTask, setHoveredTask] = useState({});
    const clickTimeout = useRef(null);
    const selectedColumnsRef = useRef({ cols: [], isChange: false });
    const [taskLoader, setTaskLoader] = useState({});
    const filterFields = [
        {
            label: "Projects",
            name: "projects",
            col: "12",
            type: "multiselect",
            option: option?.projects,
            optionLabel: "project_name",
            labelClassName: "task-list-filter-label",
            placeholder: "Select project",
            onHide: () => {
                if (filterValue?.isChange) {
                    handleProjectChange();
                }
            }
        },
    ]
    const ImgCompo = ({ item, fromMultiselect }) => {
        const [err, setErr] = useState({});
        const width = fromMultiselect ? 20 : 30;
        const font = fromMultiselect ? "10px" : "13px"
        return <div className='d-flex gap-2'>
            {err ?
                <div title={item?.user_display_name}>{getUserInitials(item?.user_display_name, { width: width, height: width, fontSize: font })}</div>
                : <img className='rounded-circle' src={item?.assignee_image_url || ""} alt='' width={width} height={width} onError={() => setErr(true)} />
            }
            {fromMultiselect && <div>{item?.user_display_name}</div>}
        </div>
    }
    const filterKeys = {
        features: {
            id: "feature_issue_id", key: "issue_key", label: "Parent", render: (item, fromMultiselect) => {
                return <div className={`d-flex ${fromMultiselect ? "gap-2" : "gap-1"} align-items-center px-2`}>
                    <img src={item?.image_url || ""} alt="" width={15} height={15} />
                    <div>{item?.issue_key}</div>
                </div>
            }
        },
        assignee: {
            id: "assignee_user_code", key: "user_display_name", label: "Assignee", type: "img", render: (item, fromMultiselect) => {
                return <ImgCompo item={item} fromMultiselect={fromMultiselect} />
            }
        },
        issue_type: { id: "issue_type_id", key: "issue_type_name", label: "Work Type" },
        reporters: {
            id: "reporter_user_code", key: "user_display_name", label: "Reporter", type: "img", render: (item, fromMultiselect) => {
                return <ImgCompo item={item} fromMultiselect={fromMultiselect} />
            }
        },
        issue_status: {
            id: "status_id", key: "status_name", label: "Status", render: (item) => {
                return <div className='px-2'>{item?.status_name}</div>
            }
        },
    }
    const optionCount = {
        features: 6,
        assignee: 12,
        reporters: 9,
        issue_type: 6,
        issue_status: 5,
    }

    const columns = [
        {
            key: "issue_type",
            label: "Type",
            style: { width: "100px" },
            toggleIcon: true,
            render: (row) => {
                return (
                    <div className="text-white">
                        <img src={row?.image_url} alt='' width={16} height={16} />
                    </div>
                )
            },
        },
        {
            key: "issue_key",
            label: "Key",
            style: { width: "130px" },
            render: (row) => (
                <div className="d-flex justify-content-between align-items-center p-2" onMouseEnter={() => setHoveredTask((prev) => ({ ...prev, [row?.issue_id]: true }))} onMouseLeave={() => setHoveredTask((prev) => ({ ...prev, [row?.issue_id]: false }))}>
                    <div className="text-primary c-pointer fw-semibold text-truncate text-decoration-underline" title={row?.issue_url && 'Double click to re-direct'}
                        onClick={(e) => {
                            clickTimeout.current = setTimeout(() => {
                                setTaskDetailsPopup({ show: true, data: row });
                            }, 200);
                        }}
                        onDoubleClick={() => { clearTimeout(clickTimeout.current); if (row?.issue_url) { window.open(row.issue_url, "_blank", "noopener,noreferrer"); } }}>{row?.issue_key}</div>
                    <div className='d-flex align-items-center gap-2'>
                        {row?.issue_url && hoveredTask?.[row?.issue_id] && <div className='c-pointer' title='Copy link' onClick={() => { navigator.clipboard.writeText(row?.issue_url); showSuccess("Success", "Url Copied!") }}><FontAwesomeIcon icon="fa-solid fa-link" /></div>}
                        {row?.issue_url && hoveredTask?.[row?.issue_id] && <div className='c-pointer' title='Copy Task ID' onClick={() => { navigator.clipboard.writeText(row?.issue_key); showSuccess("Success", "Task ID Copied!") }}><FontAwesomeIcon icon="fa-solid fa-copy" /></div>}
                    </div>
                </div>
            )
        },
        {
            key: "issue_summary",
            label: "Summary",
            style: { width: "400px", flex: 1 },
            render: (row) => <div className=" fw-semibold text-truncate">{row?.issue_summary || "-"}</div>
        },
        {
            key: "status_name",
            label: "Status",
            style: { width: "120px" },
            render: (row) => {
                if (!row?.status_name) return null;
                const status = row?.status_name
                const getStatusStyle = () => {
                    if (status?.toLowerCase() === 'done' || status?.toLowerCase() === 'RESOLVED') return { backgroundColor: '#b3df72' };
                    if (status?.toLowerCase() === 'in progress') return { backgroundColor: '#579dff', };
                    if (status?.toLowerCase() === 'dev done') return { backgroundColor: '#8fb8f6' };
                    if (status?.toLowerCase() === 'backlog' || status?.toLowerCase() === 'sprint backlog') return { backgroundColor: '#dddee1' };
                    return { backgroundColor: '#dddee1' };
                };
                if (!row?.issue_id) return <span>-</span>;
                const rowKey = row?.issue_id;
                const rowOptions = statusOptionsByRow[rowKey] || [];
                const rowSelected = selectedStatusByRow[rowKey] || _.findWhere(rowOptions, { name: row?.status_name }) || { id: `${row?.issue_id}-current`, name: row?.status_name };
                return (
                    taskLoader?.[row?.issue_id] ?
                        <div style={{ height: "30px" }}><SkeletonContainer /></div> :
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'stretch', width: '100%', height: '100%', ...getStatusStyle() }} title={row?.status_name?.trim() === "Code Review" ? `Reviewer: ${row?.reviewer_user_display_name}` : ""} >
                            <Dropdown
                                className="tast-list-dd"
                                value={rowSelected}
                                options={rowOptions}
                                style={{ width: '100%', height: '100%', backgroundColor: 'transparent', fontWeight: "500", border: 'none', }}
                                onChange={(e) => {
                                    const newStatus = e?.value
                                    if (newStatus?.name?.trim() === "Code Review") {
                                        getProjectUser(row?.project_id)
                                        setPopupValue({ show: true, file: [], row, newStatus, fileInput: ["qa-web", "qa-api", "qa-app"]?.includes(row?.issue_type_name?.toLowerCase()) })
                                        return;
                                    }
                                    handleStatusChangeApiCall(row, newStatus)
                                }}
                                optionLabel="name"
                                placeholder={row?.status_name || 'Select Status'}
                                onClick={() => !rowOptions?.length && loadStatusOptions(row)}
                            />
                        </div>
                );
            },
        },
        {
            key: "assignee_user_name",
            label: "Assignee",
            style: { width: "120px" },
            render: (row) => {

                const name = row?.isParent ? row?.parentassigneeusername : row?.assignee_user_name || "";
                if (!name) return <div >-</div>;
                return (
                    <div className="px-1 d-flex gap-2 fw-semibold align-items-center" style={{ color: "#6B778C" }} >
                        {filterValue?.assigneeImgError?.[row?.issue_id] ? <div>{getUserInitials(name, { width: 25, height: 25, fontSize: "12px" })}</div> :
                            <img className="rounded-circle" src={row?.assignee_image_url || ""} width={25} height={25} onError={() => { setFilterValue((prev) => ({ ...prev, assigneeImgError: { ...prev?.assigneeImgError, [row?.issue_id]: true } })) }} alt='' />
                        }
                        <div className='text-truncate'>{name}</div>
                    </div>
                );
            },
        },
        {
            key: "priority_name",
            label: "Priority",
            style: { width: "80px" },
            render: (row) => {
                const priority = row?.priority_name || "";

                if (!priority) return <div >-</div>;

                return (
                    <div className=" d-flex gap-2 align-items-center fw-semibold">
                        {getPriorityIcon(priority)} {priority}
                    </div>
                );
            },
        },
        {
            key: "created_datetime",
            label: "Created",
            style: { width: "150px" },
            render: (row) => (

                <div
                    className=" d-flex gap-2 align-items-center fw-semibold text-truncate"
                    style={{ color: "#6B778C" }}
                >
                    <FontAwesomeIcon icon={faCalendar} />
                    <div className='text-truncate' >
                        {row?.created_datetime
                            ? dateConvert(row?.created_datetime, "date-time-months")
                            : "-"}
                    </div>

                </div>
            )
        },
        {
            key: "updated_datetime",
            label: "Updated",
            style: { width: "150px" },

            render: (row) => (
                <div
                    className=" d-flex gap-2 align-items-center fw-semibold text-truncate"
                    style={{ color: "#6B778C" }}
                >
                    <FontAwesomeIcon icon={faCalendar} />
                    <div className='text-truncate' >
                        {row?.updated_datetime
                            ? dateConvert(row?.updated_datetime, "date-time-months")
                            : "-"}
                    </div>
                </div>
            )
        },
        {
            key: "reporter_user_name",
            label: "Reporter",
            style: { width: "130px" },
            render: (row) => {
                return (
                    <div className=" d-flex gap-2 fw-semibold text-truncate align-items-center" style={{ color: '#6B778C', fontSize: "12px" }}>
                        {filterValue?.reporterImgError?.[row?.issue_id] ? <div>{getUserInitials(row?.reporter_user_name, { width: 25, height: 25, fontSize: "12px" })}</div> :
                            <img className="rounded-circle" src={row?.reporter_image_url || ""} width={25} height={25} onError={(e) => { setFilterValue((prev) => ({ ...prev, reporterImgError: { ...prev?.reporterImgError, [row?.issue_id]: true } })) }} alt='' />
                        }

                        <div className='text-truncate'>{row?.reporter_user_name}</div>
                    </div>
                );
            },
        },
        {
            key: "child_timespent",
            label: "Time Spent",
            style: { width: "120px" },
            render: (row) => {
                return (
                    <div className='px-2'>
                        {row?.child_timespent && <div className="px-2 fw-semibold rounded" style={{ color: '#484e57', width: "fit-content", border: "1px solid #c2c4c7", fontSize: "12px" }}>{row?.child_timespent}</div>}
                    </div>
                )
            }
        },
        {
            key: "child_original_estimate",
            label: "Original Estimate",
            style: { width: "120px" },
            render: (row) => {
                return (
                    <div className='px-2'>
                        {row?.child_original_estimate && <div className="px-2 fw-semibold rounded" style={{ color: '#484e57', width: "fit-content", border: "1px solid #c2c4c7", fontSize: "12px" }}>{row?.child_original_estimate}</div>}
                    </div>
                )
            }
        },
    ];

    // const defaultCols = [
    //     {
    //         key: "issue_type",
    //         label: "Type",
    //         style: { width: "100px" },
    //         toggleIcon: true,
    //         render: (row) => {
    //             return (
    //                 <div className="text-white">
    //                     <img src={row?.image_url} alt='' width={16} height={16} />
    //                 </div>
    //             )
    //         },
    //     },
    //     {
    //         key: "issue_key",
    //         label: "Key",
    //         style: { width: "130px" },
    //         render: (row) => (
    //             <div className="d-flex justify-content-between align-items-center p-2" onMouseEnter={() => setHoveredTask((prev) => ({ ...prev, [row?.issue_id]: true }))} onMouseLeave={() => setHoveredTask((prev) => ({ ...prev, [row?.issue_id]: false }))}>
    //                 <div className="text-primary c-pointer fw-semibold text-truncate text-decoration-underline" title={row?.issue_url && 'Double click to re-direct'}
    //                     onClick={(e) => {
    //                         clickTimeout.current = setTimeout(() => {
    //                             setTaskDetailsPopup({ show: true, data: row });
    //                         }, 200);
    //                     }}
    //                     onDoubleClick={() => { clearTimeout(clickTimeout.current); if (row?.issue_url) { window.open(row.issue_url, "_blank", "noopener,noreferrer"); } }}>{row?.issue_key}</div>
    //                 <div className='d-flex align-items-center gap-2'>
    //                     {row?.issue_url && hoveredTask?.[row?.issue_id] && <div className='c-pointer' title='Copy link' onClick={() => { navigator.clipboard.writeText(row?.issue_url); showSuccess("Success", "Url Copied!") }}><FontAwesomeIcon icon="fa-solid fa-link" /></div>}
    //                     {row?.issue_url && hoveredTask?.[row?.issue_id] && <div className='c-pointer' title='Copy Task ID' onClick={() => { navigator.clipboard.writeText(row?.issue_key); showSuccess("Success", "Task ID Copied!") }}><FontAwesomeIcon icon="fa-solid fa-copy" /></div>}
    //                 </div>
    //             </div>
    //         )
    //     },
    //     {
    //         key: "issue_summary",
    //         label: "Summary",
    //         style: { width: "400px", flex: 1 },
    //         render: (row) => <div className=" fw-semibold text-truncate">{row?.issue_summary || "-"}</div>
    //     },
    // ]
    // const [columns, setColumns] = useState(defaultCols);
    // const columnRender = {
    //     estimated_time: {
    //         style: { width: "120px" },
    //         render: (row) => {
    //             return (
    //                 <div className='px-2'>
    //                     {row?.child_original_estimate && <div className="px-2 fw-semibold rounded" style={{ color: '#484e57', width: "fit-content", border: "1px solid #c2c4c7", fontSize: "12px" }}>{row?.child_original_estimate}</div>}
    //                 </div>
    //             )
    //         }
    //     },
    //     status_name: {
    //         style: { width: "120px" },
    //         render: (row) => {
    //             if (!row?.status_name) return null;
    //             const status = row?.status_name
    //             const getStatusStyle = () => {
    //                 if (status?.toLowerCase() === 'done' || status?.toLowerCase() === 'RESOLVED') return { backgroundColor: '#b3df72' };
    //                 if (status?.toLowerCase() === 'in progress') return { backgroundColor: '#579dff', };
    //                 if (status?.toLowerCase() === 'dev done') return { backgroundColor: '#8fb8f6' };
    //                 if (status?.toLowerCase() === 'backlog' || status?.toLowerCase() === 'sprint backlog') return { backgroundColor: '#dddee1' };
    //                 return { backgroundColor: '#dddee1' };
    //             };
    //             if (!row?.issue_id) return <span>-</span>;
    //             const rowKey = row?.issue_id;
    //             const rowOptions = statusOptionsByRow[rowKey] || [];
    //             const rowSelected = selectedStatusByRow[rowKey] || { id: `${row?.issue_id}-current`, name: row?.status_name };
    //             return (
    //                 taskLoader?.[row?.issue_id] ?
    //                     <div style={{ height: "30px" }}><SkeletonContainer /></div> :
    //                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'stretch', width: '100%', height: '100%', ...getStatusStyle() }} title={row?.status_name?.trim() === "Code Review" ? `Reviewer: ${row?.reviewer_user_display_name}` : ""} >
    //                         <Dropdown
    //                             className="tast-list-dd"
    //                             value={rowSelected}
    //                             options={rowOptions}
    //                             style={{ width: '100%', height: '100%', backgroundColor: 'transparent', fontWeight: "500", border: 'none', }}
    //                             onChange={(e) => {
    //                                 const newStatus = e?.value
    //                                 if (newStatus?.name?.trim() === "Code Review") {
    //                                     getProjectUser(row?.project_id)
    //                                     setPopupValue({ show: true, file: [], row, newStatus, fileInput: ["qa-web", "qa-api", "qa-app"]?.includes(row?.issue_type_name?.toLowerCase()) })
    //                                     return;
    //                                 }
    //                                 handleStatusChangeApiCall(row, newStatus)
    //                             }}
    //                             optionLabel="name"
    //                             placeholder={row?.status_name || 'Select Status'}
    //                             onClick={() => !rowOptions?.length && loadStatusOptions(row)}
    //                         />
    //                     </div>
    //             );
    //         }
    //     },
    //     component_name: {
    //         style: { width: "120px" },
    //         render: (row) => {
    //             const name = row?.assignee_user_name || "";
    //             if (!name) return <div >-</div>;
    //             return (
    //                 <div className="px-1 d-flex gap-2 fw-semibold align-items-center" style={{ color: "#6B778C" }} >
    //                     {filterValue?.assigneeImgError?.[row?.issue_id] ? <div>{getUserInitials(name, { width: 25, height: 25, fontSize: "12px" })}</div> :
    //                         <img className="rounded-circle" src={row?.assignee_image_url || ""} width={25} height={25} onError={() => { setFilterValue((prev) => ({ ...prev, assigneeImgError: { ...prev?.assigneeImgError, [row?.issue_id]: true } })) }} alt='' />
    //                     }
    //                     <div className='text-truncate'>{name}</div>
    //                 </div>
    //             );
    //         }
    //     },
    //     created_datetime: {
    //         style: { width: "150px" },
    //         render: (row) => (
    //             <div className=" d-flex gap-2 align-items-center fw-semibold text-truncate" style={{ color: "#6B778C" }} >
    //                 <FontAwesomeIcon icon={faCalendar} />
    //                 <div className='text-truncate' >{row?.created_datetime ? dateConvert(row?.created_datetime, "date-time-months") : "-"}</div>
    //             </div>
    //         )
    //     },
    //     updated_datetime: {
    //         style: { width: "150px" },
    //         render: (row) => (
    //             <div className=" d-flex gap-2 align-items-center fw-semibold text-truncate" style={{ color: "#6B778C" }} >
    //                 <FontAwesomeIcon icon={faCalendar} />
    //                 <div className='text-truncate' >{row?.updated_datetime ? dateConvert(row?.updated_datetime, "date-time-months") : "-"}</div>
    //             </div>
    //         )
    //     },
    // }

    useEffect(() => {
        callautopopulate("agile_groups", "projects", "issue_status").then(async res => {
            setOption((prev) => ({ ...prev, agileGroups: res?.agile_groups, projects: res?.projects?.sort((a, b) => a?.project_name?.localeCompare(b?.project_name)), issue_status: res?.issue_status?.sort((a, b) => a?.status_name?.localeCompare(b?.status_name)) }))
        })
        const savedFilters = sessionStorage.getItem("task_filters");
        if (savedFilters) {
            const decryptedFilters = JSON.parse(decryptData(savedFilters));
            const filters = {
                ...decryptedFilters,
                createdDate: decryptedFilters?.createdDate?.[0] ? [new DateObject(decryptedFilters?.createdDate?.[0]), new DateObject(decryptedFilters?.createdDate?.[1])] : [],
                updatedDate: decryptedFilters?.updatedDate?.[0] ? [new DateObject(decryptedFilters?.updatedDate?.[0]), new DateObject(decryptedFilters?.updatedDate?.[1])] : [],
                startDate: decryptedFilters?.startDate ? new Date(decryptedFilters?.startDate) : null,
                dueDate: decryptedFilters?.dueDate ? new Date(decryptedFilters?.dueDate) : null,
                filterLoaded: true, isChange: false
            }
            setFilterValue((prev) => ({ ...prev, ...filters }));
            if (decryptedFilters?.projects?.length > 0) {
                handleProjectChange(false, { ...filterValue, ...filters })
            } else {
                getTaskList(false, { ...filterValue, ...filters })
            }
        } else {
            setFilterValue((prev) => ({ ...prev, filterLoaded: true }));
            getTaskList();
        }
    }, [])

    useEffect(() => {
        handleGrouping();
    }, [filterValue?.groups, tasks])

    useEffect(() => {
        if (filterValue?.selectedFilterKey) {
            const selected = filterKeys?.[filterValue?.selectedFilterKey];
            if (!_.isEmpty(filterValue?.selectedFilterKey)) {
                let opts = option?.[filterValue?.selectedFilterKey] ? [...option?.[filterValue?.selectedFilterKey]] : [];
                const sortedOpts = filterValue?.[filterValue?.selectedFilterKey]?.concat(_.filter(opts, item => !_.pluck(filterValue?.[filterValue?.selectedFilterKey], selected?.id)?.includes(item?.[selected?.id]))?.sort((a, b) => a?.[selected?.key]?.localeCompare(b?.[selected?.key])));
                setOption((prev) => ({ ...prev, [filterValue?.selectedFilterKey]: sortedOpts }))
                getTaskList();
            } else {
                const currentOpts = option?.[filterValue?.selectedFilterKey]?.sort((a, b) => a?.[selected?.key]?.localeCompare(b?.[selected?.key]));
                if (!_.isEqual(option?.[filterValue?.selectedFilterKey], currentOpts)) {
                    setOption((prev) => ({
                        ...prev,
                        [filterValue?.selectedFilterKey]: currentOpts
                    }))
                }
            }
        }
    }, [filterValue?.selectedFilterKey]);

    useEffect(() => {
        filterValue?.filterLoaded && getTaskList();
    }, [pagination?.current_page])

    useEffect(() => {
        if (!_.isEqual(displayColumns?.selected, selectedColumnsRef?.current?.cols)) {
            selectedColumnsRef.current.cols = displayColumns?.selected;
            const selectedCols = displayColumns?.selected?.map(item => {
                const findData = _.findWhere(configOpts, { column_id: item?.column_id });
                if (findData) {
                    return findData;
                }
            })
            setFilterValue((prev) => ({ ...prev, columnConfig: selectedCols }));
        }
    }, [displayColumns?.selected])

    // useEffect(() => {
    //     if (!_.isEmpty(selectedColumnsRef?.current?.cols)) {
    //         setColumns((prev) => {
    //             let cols = [...defaultCols];
    //             selectedColumnsRef?.current?.cols?.forEach(col => {
    //                 if (_.isEmpty(_.findWhere(cols, { key: col?.column_display_name }))) {
    //                     cols?.push({
    //                         key: col?.column_display_name || "",
    //                         label: col?.column_label_name,
    //                         style: { ...columnRender?.[col?.column_display_name]?.style, width: columnRender?.[col?.column_display_name]?.style?.width || "200px" },
    //                         allowHide: true,
    //                         render: (row) => {
    //                             return (
    //                                 <div>
    //                                     {columnRender?.[col?.column_display_name]?.render ? columnRender?.[col?.column_display_name]?.render(row) : row?.[col?.column_display_name]}
    //                                 </div>
    //                             )
    //                         },
    //                     },)
    //                 }
    //             })
    //             return cols;
    //         })
    //     }
    // }, [selectedColumnsRef?.current?.cols, filterValue?.assigneeImgError, statusOptionsByRow, taskLoader])

    useEffect(() => {
        if (filterValue?.firstTimeApi && filterValue?.isChange) {
            sessionStorage.setItem("task_filters", encryptData(JSON.stringify({...filterValue, search: ""})));
        }
    }, [filterValue])

    const handleStatusChangeApiCall = async (row, newStatus) => {
        setTaskLoader((prev) => ({ ...prev, [row?.issue_id]: true }));
        const res = await handleStatusChange(row, newStatus, true)
        if (res) {
            const savedScroll = taskListRef?.current?.scrollTop
            // setLoader(true);
            setTimeout(() => {
                getTaskList(savedScroll, null, row);
                setExpanded(true)
            }, 3500);
        } else {
            const findOpt = _.findWhere(statusOptionsByRow, { name: row?.status_name });
            setSelectedStatusByRow((prev) => ({ ...prev, [row?.issue_id]: findOpt }));
            setTaskLoader((prev) => ({ ...prev, [row?.issue_id]: false }))
        }
    }

    const getTaskList = async (scrollTop, filters, statusRow) => {
        try {
            !statusRow && setLoader(true);
            setFilterValue((prev) => ({ ...prev, assigneeImgError: {}, reporterImgError: {} }));
            let appliedFilters = filters || filterValue;
            const payload = {
                issue_view_type: filterValue?.groups?.group_key || "",
                project_ids: _.pluck(appliedFilters?.projects, "project_id")?.toString() || "",
                page_number: pagination?.current_page || 1,
                from_date: appliedFilters?.createdDate?.[0] ? formatDateObject(appliedFilters?.createdDate?.[0]) : "",
                to_date: appliedFilters?.createdDate?.[1] ? formatDateObject(appliedFilters?.createdDate?.[1]) : "",
                start_date: appliedFilters?.startDate ? dateConvert(appliedFilters?.startDate, "iso-string")?.split(".")?.[0] : "",
                due_date: appliedFilters?.dueDate ? dateConvert(appliedFilters?.dueDate, "iso-string")?.split(".")?.[0] : "",
                update_from_date: appliedFilters?.updatedDate?.[0] ? formatDateObject(appliedFilters?.updatedDate?.[0]) : "",
                update_to_date: appliedFilters?.updatedDate?.[1] ? formatDateObject(appliedFilters?.updatedDate?.[1]) : "",
                assignee_user_codes: _.pluck(appliedFilters?.assignee, "assignee_user_code")?.toString() || "",
                features_issue_ids: _.pluck(appliedFilters?.features, "feature_issue_id")?.toString() || "",
                reporter_user_codes: _.pluck(appliedFilters?.reporters, "reporter_user_code")?.toString() || "",
                status_ids: _.pluck(appliedFilters?.issue_status, "status_id")?.toString() || "",
                issue_type_ids: _.pluck(appliedFilters?.issue_type, "issue_type_id")?.toString() || "",
            };
            const res = await services.getInvokeRemote("POST", Urls("GETEMPLOYEETASKLIST"), payload);
            if (res?.body?.error_status === false) {
                const apiTasks = res?.body?.data?.employee_task_list || [];
                const paginationData = res?.body?.data?.table1?.[0];
                const grouped = formatAllData(apiTasks);
                setTimeout(() => {
                    if (taskListRef?.current) {
                        taskListRef.current.scrollTop = scrollTop || 0;
                    }
                }, 50);
                setRowData([{ id: "all", title: "", children: Object.values(grouped) }]);
                setTasks([{ id: "all", title: "", children: Object.values(grouped) }]);
                setFilterValue((prev) => ({ ...prev, allTasks: apiTasks }));
                setPagination((prev) => ({ ...prev, total_records: paginationData?.total_issues, total_pages: paginationData?.paging, display_page_out_of_total: paginationData?.current_records }));
                if (statusRow) {
                    const findTask = _.findWhere(apiTasks, { issue_id: statusRow?.issue_id });
                    const findOpt = _.findWhere(statusOptionsByRow?.[statusRow?.issue_id], { name: findTask?.status_name });
                    setSelectedStatusByRow((prev) => ({ ...prev, [statusRow?.issue_id]: findOpt }));
                } else {
                    setStatusOptionsByRow({});
                }
            }
        } catch (error) {
            console.error("API Error:", error);
            setRowData([]);
            setPagination((prev) => ({
                ...prev,
                total_records: 0,
                total_pages: 0,
                display_page_out_of_total: "0 of 0",
            }));
        } finally {
            setLoader(false);
            setFilterValue((prev) => ({ ...prev, isChange: false, apiCall: false, selectedFilterKey: prev?.selectedFilterKey !== "reset" ? "" : prev?.selectedFilterKey, firstTimeApi: true }));
            statusRow && setTaskLoader((prev) => ({ ...prev, [statusRow?.issue_id]: false }));
        }
    };

    const handleProjectChange = async (emptyProject, allFilters) => {
        const data = await getSubProject(emptyProject ? [] : _.pluck((allFilters || filterValue)?.projects, "project_id"), ["is_issue_type", "is_reporter", "is_features", "is_project_assignee"]);
        setOption((prev) => ({
            ...prev,
            features: data?.feature?.sort((a, b) => b?.issue_key?.localeCompare(a?.issue_key)),
            reporters: data?.reporters,
            issue_type: data?.issueType,
            assignee: data?.projectAssignee
        }));
        let filters = { ...(allFilters || filterValue) };
        filters = {
            ...filters,
            projects: emptyProject ? [] : filters?.projects,
            assignee: _.filter(filters?.assignee, item => _.pluck(data?.projectAssignee, "assignee_user_code")?.includes(item?.assignee_user_code)),
            features: _.filter(filters?.features, item => _.pluck(data?.feature, "feature_issue_id")?.includes(item?.feature_issue_id)),
            reporters: _.filter(filters?.reporters, item => _.pluck(data?.reporters, "reporter_user_code")?.includes(item?.reporter_user_code)),
            issue_type: _.filter(filters?.issue_type, item => _.pluck(data?.issueType, "issue_type_id")?.includes(item?.issue_type_id)),
        }
        setFilterValue((prev) => ({ ...prev, ...filters }))
        getTaskList(null, filters);
    }

    const handleChange = (e) => {
        const { name, value } = e?.target
        setFilterValue((prev) => ({ ...prev, [name]: value, isChange: true }));
    }

    const handleGrouping = (data) => {
        let allFormatted = [];
        const keys = {
            assignee: { key: "assignee_user_name", id: "assignee_user_code" },
            status: { key: "status_name", id: "status_id" },
            priority: { key: "priority_name", id: "priority_id" },
            sprint: {key: "sprint_name", id: "sprint_id"}
        }
        if (filterValue?.groups?.group_key !== undefined && keys?.[filterValue?.groups?.group_key]) {
            const formattedData = transformData(data || tasks, keys?.[filterValue?.groups?.group_key]);
            if (data) return formattedData;
            setExpanded(true)
            setRowData(formattedData);
        } else {
            if (data) return data ? [...data] : [...tasks];
            setRowData([...tasks]);
            allFormatted = [...tasks];
        }
    }

    const transformData = (data, group) => {
        const allIssues = data?.[0]?.children || [];

        const groupedMap = {};

        const processNode = (node, parentChain = []) => {

            if (!_.isEmpty(node?.children)) {
                node.children.forEach(child => {
                    processNode(child, [...parentChain, node]);
                });
                return;
            }

            const groupValue = node?.[group?.key] || "Unassigned";

            if (!groupedMap[groupValue]) {
                groupedMap[groupValue] = {
                    id: `group-${node?.[group?.id] || groupValue}`,
                    title: groupValue,
                    children: {}
                };
            }

            let currentLevel = groupedMap[groupValue].children;

            parentChain.forEach((parent, index) => {
                const parentKey = parent?.issue_id || `level-${index}`;
                if (!currentLevel[parentKey]) {
                    currentLevel[parentKey] = {
                        id: `parent-${parentKey}`,
                        title: parent?.issue_summary || "Untitled",
                        issue_id: parent?.issue_id,
                        issue_key: parent?.issue_key,
                        issue_summary: parent?.issue_summary,
                        image_url: parent?.image_url,
                        status_name: parent?.status_name,
                        reporter_user_name: parent?.reporter_user_name,
                        reporter_image_url: parent?.reporter_image_url,
                        created_datetime: parent?.created_datetime,
                        updated_datetime: parent?.updated_datetime,
                        priority_name: parent?.priority_name,
                        child_timespent: parent?.child_timespent,
                        child_original_estimate: parent?.child_original_estimate,
                        issue_url: parent?.issue_url,
                        children: {}
                    };
                }
                currentLevel = currentLevel[parentKey].children;
            });
            currentLevel[`task-${node.issue_id}`] = { ...node, children: [] };
        };

        allIssues.forEach(parent => {
            processNode(parent);
        });

        const convertChildrenToArray = (obj) => {
            return Object.values(obj).map(item => ({ ...item, children: item?.children && !Array.isArray(item?.children) ? convertChildrenToArray(item?.children) : item?.children || [] }));
        };

        return Object.values(groupedMap).map(group => ({ ...group, children: convertChildrenToArray(group?.children) }));
    };

    const formatAllData = (data) => {
        const grouped = data?.reduce((acc, issue) => {
            const findParent = (item) => {
                const findParentAsChild = _.findWhere(data, { issue_id: item?.parent_issue_id });
                if (findParentAsChild) {
                    findParent(findParentAsChild);
                } else {
                    return item;
                }
            }

            const findChildren = (item) => {
                let children = [];
                const hasChildren = _.filter(data, child => child?.parent_issue_id === item?.issue_id);
                if (!_.isEmpty(hasChildren)) {
                    const allChildren = hasChildren?.map(child => {
                        return { ...child, children: findChildren(child) }
                    })
                    return allChildren;
                } else {
                    return []
                }
            }

            const parent = findParent(issue);
            if (parent) {
                const parentObj = {
                    id: parent?.parent_issue_id || "standalone",
                    title: parent?.parent_issue_summary || "Standalone Tasks",
                    children: [],
                    issue_id: parent?.parent_issue_id || parent?.issue_id,
                    issue_key: parent?.parent_issue_key || parent?.issue_key,
                    issue_summary: parent?.parent_issue_summary || parent?.issue_summary,
                    image_url: parent?.parent_issue_image_url || parent?.image_url,
                    status_name: parent?.parent_status_name || parent?.status_name,
                    reporter_user_name: parent?.parent_reporter_user_name || parent?.reporter_user_name,
                    reporter_image_url: parent?.parent_reporter_image_url || parent?.reporter_image_url,
                    created_datetime: parent?.parent_created_datetime || parent?.created_datetime,
                    updated_datetime: parent?.parent_updated_datetime || parent?.updated_datetime,
                    priority_name: parent?.parent_priority_name || parent?.priority_name,
                    child_timespent: parent?.feature_total_timespent || parent?.child_timespent,
                    child_original_estimate: parent?.feature_total_original_estimate || parent?.child_original_estimate,
                    issue_url: parent?.parent_issue_url || parent?.issue_url,
                    sprint_name: parent?.sprint_name || "",
                    sprint_id: parent?.sprint_id || 0,
                }
                acc[parent?.parent_issue_summary || parent?.issue_summary] = { ...parentObj, children: findChildren(parentObj) };
            }

            return acc;
        }, {});
        return grouped;
    }

    // const filteredData = useMemo(() => {
    //     if (!filterValue?.search?.trim()) return rowdata;
    //     const filtered = filterValue?.allTasks?.filter((item) => {
    //         return item?.issue_key?.toLowerCase()?.includes(filterValue?.search?.toLowerCase()) || item?.parent_issue_key?.toLowerCase()?.includes(filterValue?.search?.toLowerCase());
    //     });
    //     const rowdataa = formatAllData(filtered);
    //     const grouped = handleGrouping([{ id: "all", title: "", children: Object.values(rowdataa) }]);
    //     return grouped;
    // }, [filterValue?.allTasks, filterValue?.search, rowdata]);

    const filteredData = useMemo(() => {
        if (!filterValue?.search?.trim()) return rowdata;

        const search = filterValue?.search?.toLowerCase();
        const matchedTasks = filterValue?.allTasks.filter((item) => item?.issue_key?.toLowerCase()?.includes(search) || item?.parent_issue_key?.toLowerCase()?.includes(search));
        const taskMap = _.indexBy(filterValue?.allTasks, "issue_id");
        const resultMap = {};

        const addWithParents = (task) => {
            if (!task || resultMap[task?.issue_id]) return;
            resultMap[task?.issue_id] = task;
            const parentTask = taskMap[task?.parent_issue_id];
            if (parentTask) addWithParents(parentTask);
        };

        matchedTasks.forEach(addWithParents);
        const formatted = formatAllData(Object.values(resultMap));

        return handleGrouping([{ id: "all", title: "", children: Object.values(formatted) }]);
    }, [filterValue?.allTasks, filterValue?.search, rowdata]);

    const handleReset = async () => {
        const emptyFilter = { features: [], assignee: [], issue_type: [], reporters: [], issue_status: [], projects: [], updatedDate: null, startDate: null, dueDate: null, createdDate: [new DateObject(firstDay), new DateObject(lastDay)], status: [], isChange: true };
        setFilterValue((prev) => ({ ...prev, ...emptyFilter }));
        await handleProjectChange(true, { ...filterValue, ...emptyFilter });
    }

    return {
        columns, taskDetailsPopup, setTaskDetailsPopup, rowdata: filteredData, filterValue, setFilterValue, option, expanded, setExpanded, handleChange, pagination, setPagination, loader, getTaskList, options, popupValue, setPopupValue, updateReviewer, taskListRef, overlayRef, filterFields, optionCount, filterKeys, handleReset, handleProjectChange, multiselectRef, configOpts, listBoxOptionTemplate, displayColumns, setDisplayColumns, saveColumnConfiguration, selectedColumnsRef
    }
}